import { UILeg } from "@flights/types";

export const getFlightNumbers = (legs: UILeg[]) => {
  const flightNumbers = legs.map(({ flightInfo }) => {
    return `${flightInfo.carrierInfo?.marketingCarrier}${flightInfo.flightNumber}`;
  });

  return flightNumbers.join(", ");
};

export const getFlightNumber = (leg?: UILeg) => {
  if (!leg) return null;
  return `${leg.flightInfo.carrierInfo?.marketingCarrier}${leg.flightInfo.flightNumber}`;
};
